export default "__VITE_ASSET__78c4f403__"